import { FilterResults, PostFilterBody, screener } from '@api';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

import { hasEmptyEntityTagValues } from './utils';

export const isApiEntityScreenerV4EntitiesEnabled = () =>
  useFlags
    .getState()
    .getFeatureFlagState('DATA-1398-api_entity_screener_v4_entities');

export const getPostFilterEntitiesPath = () =>
  isApiEntityScreenerV4EntitiesEnabled()
    ? screener.postFilterv4.path
    : screener.postFilter.path;

export const fetchFilteredEntitiesTagsOnly = (
  filters: PostFilterBody,
  signal?: AbortSignal
) =>
  wretchRequest<FilterResults>(getPostFilterEntitiesPath(), {
    method: 'post',
    body: {
      filters,
      tags_only: true,
    },
    signal,
  });

export const fetchFilteredEntities = (
  filters: PostFilterBody,
  signal?: AbortSignal
) => {
  if (hasEmptyEntityTagValues(filters)) {
    return Promise.resolve({
      entities: [],
      data: [],
      page: {
        current: 0,
        size: 0,
        next: undefined,
      },
      total_count: 0,
    });
  }

  return wretchRequest<FilterResults>(getPostFilterEntitiesPath(), {
    method: 'post',
    body: {
      filters,
      tags_only: false,
    },
    signal,
  });
};
